import MetadataManager from './common/MetadataManager';
import { useTranslation } from 'react-i18next';

export default function CategoryManagement() {
  const { t } = useTranslation();

  return (
    <MetadataManager
      title={t('settings.categoryManagement.title')}
      type="categories"
      description={t('settings.categoryManagement.description')}
    />
  );
}
